import React, { useEffect, useRef } from "react";
import { Form, Container, Button, Row, Col } from "react-bootstrap";
import lottie from "lottie-web";
import Fade from "react-reveal/Fade";

const Contact = () => {
  const container = useRef(null);

  useEffect(() => {
    lottie.loadAnimation({
      container: container.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: require("../../../animation/contact.json"),
    });
  }, [container]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container className="py-4 my-5">
      <Fade bottom>
        <h1 className="text-white text-center fw-bold fs-1 pb-4 mb-3">
          Contact With Me
        </h1>

        <Row>
          <Col xs={12} sm={12} md={12} lg={6}>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <p className="container w-50" ref={container}></p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12}>
                <div className="d-flex justify-content-center align-content-center ">
                  <p className="px-3" style={{ textAlign: "justify" }}>
                    <span className="fw-bold fs-3">
                      Md. Ahanaf Tahmid Islam
                    </span>
                    <br />{" "}
                    <span className="fw-bold fs-5">Junior Front-end Software Developer</span>
                    <br /> Connect with me via email and call in to my cell.
                    <br />
                    <i className="fas fa-phone-alt text-white"></i> Phone:
                    +88-01706348352
                    <br />
                    <i className="fas fa-envelope text-white"></i> Email:
                    tahmid231@gmail.com
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
          <Col xs={12} sm={12} md={12} lg={6}>
            <h5 className="pb-3 text-center">Message Me</h5>
            <Form
              className="border border-danger p-4 rounded-3 shadow-lg"
              action="https://formsubmit.co/tahmid231@gmail.com"
              method="POST"
            >
              <Form.Group className="mb-3">
                <Form.Label className="text-white">Enter Your Name</Form.Label>
                <Form.Control type="text" name="name" placeholder="Name" />
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label className="text-white">
                  Enter Your Email address
                </Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="name@example.com"
                />
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label className="text-white">
                  Enter Your Message
                </Form.Label>
                <Form.Control
                  as="textarea"
                  name="message"
                  rows={3}
                  placeholder="Message....."
                />
              </Form.Group>
              <div className="text-center mt-3">
                <Button variant="danger" type="submit">
                  <i className="fas fa-paper-plane text-white"></i> Send Message
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Fade>
    </Container>
  );
};

export default Contact;
